import { render, staticRenderFns } from "./SetupProfileComponent.vue?vue&type=template&id=e60665a8&"
import script from "./SetupProfileComponent.vue?vue&type=script&lang=js&"
export * from "./SetupProfileComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports